// export { default as translate } from "./translate";
export {
  default as TranslationProvider,
  useTranslation,
} from "./translation-provider";
